import { useChurchStore } from "features/churches";
import {
  useApproversPaginated,
  useBanksPaginated,
  useBudgetYearsPaginated,
  useChartOfAccounts
} from "../api";

export const useFinanceOnboardingStatus = () => {
  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const budgetYearsQuery = useBudgetYearsPaginated({
    churchId: selectedChurch?.id,
    page: 1,
    pageSize: 1
  });

  const chartOfAccountsQuery = useChartOfAccounts({
    churchId: selectedChurch?.id
  });

  const banksQuery = useBanksPaginated({
    churchId: selectedChurch?.id,
    page: 1,
    pageSize: 1
  });

  const approversQuery = useApproversPaginated({
    churchId: selectedChurch?.id,
    page: 1,
    pageSize: 1
  });

  const isLoading =
    budgetYearsQuery.isLoading ||
    chartOfAccountsQuery.isLoading ||
    banksQuery.isLoading ||
    approversQuery.isLoading;

  const isError =
    budgetYearsQuery.isError ||
    chartOfAccountsQuery.isError ||
    banksQuery.isError ||
    approversQuery.isError;

  const isOnboardingComplete =
    !isLoading &&
    !isError &&
    (budgetYearsQuery.data?.result?.total || 0) > 0 &&
    (chartOfAccountsQuery.data?.result?.length || 0) > 0 &&
    (banksQuery.data?.result?.total || 0) > 0 &&
    (approversQuery.data?.result?.total || 0) > 0;

  return {
    isLoading,
    isError,
    isOnboardingComplete
  };
};
